// extracted by mini-css-extract-plugin
export default {"faqs":"FAQ_faqs__PDHG6","faqactive":"FAQ_faqactive__hNneS","abschluss":"FAQ_abschluss__pVCJr"};